var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgErrorInverted = function SvgErrorInverted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 8,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF1E31",
    d: "M17.43 17.093L15.337 15l2.093-2.093a.238.238 0 10-.337-.337L15 14.663l-2.093-2.093a.238.238 0 10-.337.337L14.663 15l-2.093 2.093a.238.238 0 10.337.337L15 15.337l2.093 2.093a.238.238 0 10.337-.337z"
  }))));
};
export default SvgErrorInverted;